import { jsx as l, jsxs as _ } from "react/jsx-runtime";
import "react";
import { classes as t } from "../../utils/helpers.js";
import { s as e } from "../../ResultsTable.module-nTlGw9Lh.mjs";
function c({ results: r = [], columns: u = [], noResultsMsg: b = "No results were returned" }) {
  return r.length > 0 ? r.map((a, i) => /* @__PURE__ */ l(
    "div",
    {
      className: t([
        e["results-table__row"],
        "results-table__row"
      ]),
      children: u.map((s) => /* @__PURE__ */ _(
        "div",
        {
          className: t([
            e["results-table__item"],
            `results-table__${s.title.replace(" ", "-").toLowerCase()}`,
            "results-table__item"
          ]),
          children: [
            /* @__PURE__ */ _("span", { className: t([
              e["results-table__mobile-label"],
              "results-table__mobile-label"
            ]), children: [
              s.title,
              ":"
            ] }),
            Object.keys(a).includes(s.resultKey) ? a[s.resultKey] : ""
          ]
        },
        `result-${i}-${s.title}`
      ))
    },
    `result-${i}`
  )) : /* @__PURE__ */ l("div", { className: e["results-table__row"], children: /* @__PURE__ */ l(
    "div",
    {
      className: t([
        e["results-table__item"],
        e["results-table__no-results"],
        "results-table__no-results"
      ]),
      children: b
    }
  ) });
}
export {
  c as ResultsTableBody,
  c as default
};
